export enum PlayerStatusEnum {
    Hidden,
    Visible,
    Mafia,
    Dead
}